import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export function withAdminAuth(passcode) {
    return {
        headers: { "X-Admin-Passcode": passcode },
    };
}

export function formatMAD(amount) {
    return `${new Intl.NumberFormat("fr-FR").format(amount)} MAD`;
}

/**
 * Turns relative /api/files/... paths into absolute URLs using REACT_APP_BACKEND_URL.
 * Leaves absolute http(s) URLs untouched.
 */
export function resolveMediaUrl(url) {
    if (!url) return url;
    if (/^https?:\/\//i.test(url)) return url;
    if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
    return url;
}
